/* global angular */

export default function EditContactDialogController(
  $rootScope,
  $scope,
  $q,
  loaderService,
  ssDialogService,
  vmDataService,
  editContactDialog,
) {
  const vm = this;

  vm.newContact = getSanitizedContactModel(vm.contact);
  vm.handleEditContactFormSubmit = _handleEditContactFormSubmit;
  vm.handleCloseDialog = _handleCloseDialog;

  function _handleEditContactFormSubmit($event) {
    if ($scope.editContactForm.$valid) {
      const isNew = vm.newContact.contactId < 0;

      if (!isNew && angular.equals(vm.contact, vm.newContact)) {
        // No need to save
        return _closeDialog(); // or return Promise.resolve();
      }
      return _saveContact(isNew)
        .then(() => _closeDialog()
          .then(() => {
            if (vm.saveType === 'addAnother') {
              return showEditContactDialog($event, {
                contact: {
                  vendorId: vm.contact.vendorId,
                  productId: vm.contact.productId,
                  contactId: -1,
                },
                addCallback: vm.addCallback,
              });
            }
          }));
    }
  }

  function showEditContactDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editContactDialog = ssDialogService.alert(
      editContactDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editContactDialog);
  }

  function _saveContact(isNew) {
    loaderService.showViewLoader = true;
    return vmDataService.saveContact(vm.newContact)
      .then((response) => {
        loaderService.showViewLoader = false;
        const savedContact = getSanitizedContactModel(response.data);

        angular.extend(vm.newContact, savedContact);
        angular.extend(vm.contact, vm.newContact);
        if (isNew) {
          vm.addCallback(vm.contact);
        } else {
          vm.editCallback(vm.contact);
        }
        return true;
      });
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editContactDialog);
  }

  function getSanitizedContactModel(apiModel) {
    return {
      contactId: apiModel.contactId || apiModel.ContactID,
      productId: apiModel.productId || apiModel.ProductID,
      vendorId: apiModel.vendorId || apiModel.VendorID,
      name: apiModel.name || apiModel.Name,
      jobTitle: apiModel.jobTitle || apiModel.JobTitle,
      emailAddress: apiModel.emailAddress || apiModel.EmailAddress,
      phone: apiModel.phone || apiModel.Phone,
      extension: parseInt(apiModel.extension, 10) || parseInt(apiModel.Extension, 10),
      cellPhone: apiModel.cellPhone || apiModel.CellPhone,
      directLine: apiModel.directLine || apiModel.DirectLine,
    };
  }
}

EditContactDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'loaderService',
  'ssDialogService',
  'vmDataService',
  'editContactDialog',
];
